import {
  Editor,
  Transforms,
  Path,
  Node
} from 'slate';
import * as basicEditorValueSerializer from 'basic-editor-value-serializer';

import types from '../../elements/types';

import HelptapEditor from '../';

export function getDefaultOptions() {

  return basicEditorValueSerializer.utilities.node.paragraph.getDefaultOptions();

}

export function buildNode(options = {}) {

  return basicEditorValueSerializer.utilities.node.paragraph.buildNode(options);

}

export function buildWithLink(link, text) {

  const node = buildNode();
  node.children = [{
    type: types.LINK,
    url: link,
    children: [{ text, bold: true }]
  }];
  return node;

}

export function select(editor, path) {

  const node = Node.get(editor, path);

  const lastChildPath = [...path, node.children.length - 1];

  Transforms.select(editor, lastChildPath);
  Transforms.collapse(editor, { edge: 'end' });

}

export function insert(editor, path) {

  HelptapEditor.insertParagraph(editor, {}, path);
  Transforms.select(editor, [...path, 0]);
}

export function toggle(editor) {

  const nodeOptions = buildNode();

  HelptapEditor.setNodeOptions(editor, nodeOptions);

}

export function duplicate(editor, node, nodePath) {

  const clonedNode = HelptapEditor.cloneNode(node);

  HelptapEditor.insertNode(editor, clonedNode, nodePath);

}

export function isParagraphDescendantSelected(editor) {

  const nodeEntry = Editor.above(editor, {
    at: editor.selection,
    match: n => {
      return n.type === basicEditorValueSerializer.allTypes.types.DEFAULT;
    }
  });

  return !!nodeEntry;

}

/**
 * 
 * If node is empty, do nothing, as Slate will take care of deleting it.
 * If the node is last node in the editor, do nothing.
 * If the previous node is a toggle list item, remove the current node and select the previous node.
 * 
 * */
export function handleDeleteBackward(editor, node, nodePath) {

  if (HelptapEditor.isEmptyV2(editor, node) === false) {
    return false;
  }

  let targetNodePath = null;
  let targetNode = null;

  if (nodePath.length === 1) {
    if (Path.hasPrevious(nodePath) === false) {
      return false;
    }
    targetNodePath = Path.previous(nodePath);
    targetNode = Node.get(editor, targetNodePath);
  } else {
    targetNodePath = HelptapEditor.getTargetBlockNodePath(editor, Path.parent(nodePath));
    if (targetNodePath === null) {
      return false;
    }
    targetNode = Node.get(editor, targetNodePath);
  }

  if (targetNode.type === basicEditorValueSerializer.allTypes.types.TOGGLE_LIST_ITEM) {
    Transforms.removeNodes(editor, { at: nodePath });
    HelptapEditor.toggleListItem.select(editor, targetNodePath);
    return true;
  }

  return false;

}

export function convertToURLEmbed(editor, path, node, url) {

  Editor.withoutNormalizing(editor, () => {
    const urlEmbedNode = HelptapEditor.urlEmbed.buildNodeV2(url);
    Transforms.removeNodes(editor, { at: path });
    Transforms.insertNodes(editor, urlEmbedNode, { at: path });
    Transforms.insertNodes(editor, HelptapEditor.paragraph.buildNode(), { at: Path.next(path) });
    Transforms.select(editor, Path.next(path));
  });

}

export function replace(editor, path) {

  Editor.withoutNormalizing(editor, () => {

    Transforms.removeNodes(editor, { at: path });
    insert(editor, path);

  });

}